// extracted by css-extract-rspack-plugin
export default {"commentWrap":"CommentModal__commentWrap--l7F1F","textarea":"CommentModal__textarea--aVD7Q"};